export default "__VITE_ASSET__DMvtr5yo__"